<template>
  <section>
    <PagesPath
      :pathTitle="'درباره ثریا مارکت'"
      :pathTitle1="'درباره ما '"
      :pathTo1="'/about-us'"
    ></PagesPath>
    <div
      v-if="
        homeData &&
        homeData.settings &&
        homeData.settings.site &&
        homeData.settings.site.about_us_site
      "
      class="container bg-white rounded px-4 py-4"
    >
      <p>{{ homeData.settings.site.about_us_site }}</p>
    </div>
  </section>
</template>
<script>
import PagesPath from "@/parts/Front/components/PagesPath";
export default {
  name: "AboutUs",
  components: {
    PagesPath,
  },
  data() {
    return {};
  },
  computed: {
    homeData() {
      return this.$store.getters["front/getHomeData"];
    },
  },
};
</script>

<style scoped></style>
